import { render, staticRenderFns } from "./viewPolicies.vue?vue&type=template&id=179e4a06&"
import script from "./viewPolicies.vue?vue&type=script&lang=js&"
export * from "./viewPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports